import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Alert, Card, Spinner } from "react-bootstrap";
import API from "src/services/api";
import "./KPIWidget.css";

const KPIWidget = ({ title, kpiType, startDate, endDate }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [value, setValue] = useState(null);

  useEffect(() => {
    let isActive = true;

    const loadKpi = async () => {
      setLoading(true);
      setError(false);

      const result = await API.getKpi(kpiType, startDate, endDate);

      if (!isActive) {
        return;
      }

      if (!result.status) {
        setError(true);
        setValue(null);
        setLoading(false);
        return;
      }

      setValue(result.data);
      setLoading(false);
    };

    loadKpi();

    return () => {
      isActive = false;
    };
  }, [endDate, kpiType, startDate]);

  return (
    <Card className="kpi-square-widget shadow-sm">
      <Card.Body className="kpi-square-widget__body">
        <Card.Title className="kpi-square-widget__title">{title}</Card.Title>
        <div className="kpi-square-widget__content">
          {loading && (
            <div className="kpi-square-widget__state">
              <Spinner animation="border" role="status" size="sm" />
            </div>
          )}

          {!loading && error && (
            <Alert variant="danger" className="mb-0 py-2 px-3 text-center">
              KPI konnte nicht geladen werden
            </Alert>
          )}

          {!loading && !error && (
            <div className="kpi-square-widget__value">{value ?? "-"}</div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

KPIWidget.propTypes = {
  title: PropTypes.string.isRequired,
  kpiType: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
};

export default KPIWidget;
